export const GET_VENDORS = "GET_VENDORS";
export const SET_VENDORS = "SET_VENDORS";
